'use client';

import { AlarmClockLarge, BookLarge, CalendarLarge, CheckboxLarge, CommentLarge, ExtensionBase, ExtensionLarge, FolderLarge, GlobeLinesLarge, MailLarge, MoreLarge, RepeatLarge, VisualizationLarge } from '@doist/icons/brand';
import { Box, Button, ChoiceCard, Container } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import css from './category-grid.module.css';
import type { IntegrationsCategory } from 'app/[locale]/integrations/types';
const iconMap = {
  AlarmClockLarge,
  BookLarge,
  CalendarLarge,
  CommentLarge,
  FolderLarge,
  GlobeLinesLarge,
  MailLarge,
  MoreLarge,
  VisualizationLarge,
  RepeatLarge,
  ExtensionBase,
  ExtensionLarge,
  CheckboxLarge
};
function CategoryGrid({
  categories
}: {
  categories: IntegrationsCategory[];
}) {
  const {
    t
  } = useTranslation('integrationsv2');
  return <Container tag="section" className={css.categorySection} width="sm" padded data-sentry-element="Container" data-sentry-component="CategoryGrid" data-sentry-source-file="category-grid.tsx">
            <Box tag="ul" className={css.gridContainer} data-sentry-element="Box" data-sentry-source-file="category-grid.tsx">
                {categories.map(c => {
        const Icon = iconMap[c.fields.icon as keyof typeof iconMap];
        return <Box tag="li" className={css.tile} key={c.fields.slug}>
                            <ChoiceCard backgroundColor={c.fields.backgroundColor} href={`/integrations/category/${c.fields.slug}`} icon={<Icon width="32" height="32" color="var(--display-onlight-tertiary)" />}>
                                {c.fields.name}
                            </ChoiceCard>
                        </Box>;
      })}
            </Box>
            <Button variant="tertiary" href="/integrations/category/all" data-sentry-element="Button" data-sentry-source-file="category-grid.tsx">
                {t('allCategoryLinkText')}
            </Button>
        </Container>;
}
export { CategoryGrid };